import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { Edge } from 'react-native-safe-area-context';
import { SafeAreaBox, Box } from '@/components/ui/primitives';
import { BoxProps } from '@/lib/styling';

interface AppSafeAreaProps extends BoxProps {
  children: React.ReactNode;
  className?: string;
  edges?: Edge[];
  style?: StyleProp<ViewStyle>;
  contentStyle?: StyleProp<ViewStyle>;
  fill?: boolean;
}

export default function AppSafeArea({
  children,
  className,
  edges = ['left', 'right', 'bottom'],
  style,
  contentStyle,
  fill = true,
  backgroundColor = "background",
  ...rest
}: AppSafeAreaProps) {
  return (
    <SafeAreaBox
      edges={edges}
      flex={fill ? 1 : 0}
      backgroundColor={backgroundColor}
      style={style as any}
      {...rest}
    >
      <Box flex={fill ? 1 : 0} style={contentStyle as any}>
        {children}
      </Box>
    </SafeAreaBox>
  );
}
